import { useReducer } from "react";
import { useSelector as useSelectorHook } from "react-redux";

import { AppState } from "src/services/store";

export function useState<T = any>(initialData = {} as T) {
  const reducer = (state: T, action: Partial<T> | ((state: T) => Partial<T>)) => ({
    ...state,
    ...(typeof action === "function" ? action(state) : action)
  });

  return useReducer(reducer, initialData);
}

export function useSelector<TState = AppState, TSelected = unknown>(selector: (state: TState) => TSelected): TSelected {
  return useSelectorHook(selector);
}
